import { useState } from 'react';
import StoryBanner from './StoryBanner';
import StoryDescribe from './StoryDescribe';
import StoryMenu from './StoryMenu';
import StoryNewDay from './StoryNewDay';
import StoryNewLight from './StoryNewLight';
import StoryNewHouse from './StoryNewHouse';
import StoryNewTaste from './StoryNewTaste';
import StoryNewCommunity from './StoryNewCommunity';
import StoryNewWorld from './StoryNewWorld';
import StoryNewNight from './StoryNewNight';
import styled from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFVideoModal from '@/components/UI/EFVideoModal';

const StoryCompoment = () => {
    const { isMobile } = useGlobal();
    const [videoModal, setVideoModal] = useState(false);
    const [videoUrl, setVideoUrl] = useState('');

    const handleShowVideo = (url: string) => {
        console.log(url);
        setVideoUrl(url);
        setVideoModal(true);
    };

    return (
        <div className={`${isMobile ? styled.mobile_stories : styled.stories}`}>
            <StoryBanner />
            <StoryDescribe />
            <StoryMenu />
            <StoryNewDay handleShowVideo={handleShowVideo} />
            <StoryNewLight handleShowVideo={handleShowVideo} />
            <StoryNewHouse />
            <StoryNewTaste />
            <StoryNewNight />
            <StoryNewCommunity />
            <StoryNewWorld />
            <EFVideoModal visible={videoModal} source={videoUrl} onClose={() => setVideoModal(false)} playerType="YouTube" />
        </div>
    );
};

export default StoryCompoment;
